import { useEffect } from 'react';
import { throttle } from '@vkontakte/vkjs';
import { reachGoal } from '../../../../helpers';

/** Цели в веб аналитику по глубине скролла */
export function useScrollAnalytics() {
  useEffect(() => {
    const scrollHandler = throttle(() => {
      const scrollPosition = Math.floor(window.pageYOffset);
      const pageHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;

      if (scrollPosition === pageHeight) {
        reachGoal('contest_scroll_100');
        return;
      }

      if (scrollPosition >= pageHeight / 2) {
        reachGoal('contest_scroll_50');
        return;
      }
    }, 300);

    document.addEventListener('scroll', scrollHandler);

    return () => {
      document.removeEventListener('scroll', scrollHandler);
    };
  }, []);
}
